import { EProjectPlatform, IBaseConfigs } from './types';

const webConfigs: IBaseConfigs = {
  baseURL: '',
  apiDomain: '',
  apiDomainFallback: '',
  staticDomain: '',
  staticDomainFallback: '',
  platform: EProjectPlatform.WEB,
  routePathPrefix: `/${APP_ENV}`,
  socketPathPrefix: `//${location.host}`
};

export default webConfigs;
